/*
  Builds an error object to store in the reducer from either a
  JavaScript error or an API response error

  Logic is wrapped into a try catch to ensure that this utility function doesn't error
  causing the app to crash due to the unknown nature of an error object
*/

export default (error) => {
  try {
    // if we just pass a string, then return that string in a message object
    if (typeof error === 'string') return { message: error };

    // if there is an error object (from JS error or API response)
    if (typeof error === 'object') {
      const { message: passedMessage = 'Unknown Error', response } = error;

      // if network error
      if (error?.response) {
        // return the API error response and status code
        return {
          message: response?.body?.errors || passedMessage,
          statusCode: response?.statusCode,
        };
      }

      // if JS error, return error messafe
      return { message: passedMessage };
    }

    // error wasn't an object or string, so failover to a default message
    return { message: 'Unknown Error passed to buildErrorObject' };
  } catch (_) {
    return { message: 'Error Building Error Object' };
  }
};
